import React from 'react';

function SearchMeasure() {
  return <div>AddMeasure</div>;
}

export default SearchMeasure;
